<script setup>
import { usePatientStore } from "../../store/patient";
import { useRouter } from "vue-router";
import { onMounted, inject } from "vue";
import { formatFullDate } from "../../services/formatters.js";

const router = useRouter();
let patientId = ""
const patientStore = usePatientStore();
const mySpinner = inject("mySpinner");

onMounted(async () => {
  mySpinner.loading = true;
  setTimeout(() => {
    mySpinner.loading = false;
  }, 500);
  patientId = router.currentRoute.value.params.patientId;
  if(patientStore.patientsMedicalRecords.length == 0){
    await patientStore.getPatientMedicalRecords(patientId);
  }

});
const openExistMedicalRecord = (medicalRecordId) => {
  router.push(`/patients/${patientId}/records/${medicalRecordId}`);
}

</script>
<template>

<nav-bar :returnAction="true" pageName="Prontuário" @return="$router.push(`/patients`)" :createAction="true" @create="$router.push(`/patients/${patientId}/records/create`)"/> 
<main-container :onlyNav="true">
  <div class="d-flex justify-content-center">
    <h5 class="fw-bold">{{patientStore.patient.name}}</h5>
  </div>
  <list-group v-if="patientStore.patientsMedicalRecords.length > 0">
    <list-item class="list-group-item list-group-item-action px-2" style="cursor: pointer;" v-for="obj in patientStore.patientsMedicalRecords" :key="obj.id" @click="openExistMedicalRecord(obj.id)">   
      <template v-slot:title>        
        <p class="mb-1 fw-bold">{{ obj.title }}</p>
      </template> 
      <template v-slot:complement>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div class="d-flex w-100">
            <p class="mb-1">{{ formatFullDate(obj.createdAt) }}</p> 
          </div>
        </div>                              
      </template>
    </list-item>
  </list-group>
  <list-group class="list-group" v-else>
    <list-item class="list-group-item list-group-item-action">   
      <template v-slot:title>            
        <h5 class="mb-1 fw-bold">Nenhum prontuário encontrado!</h5>                        
      </template>            
    </list-item>         
  </list-group>
</main-container>   

</template>
<style lang='postcss' scoped>

</style>